import { render, staticRenderFns } from "./FinishEvent.vue?vue&type=template&id=24b0e31e"
import script from "./FinishEvent.vue?vue&type=script&lang=js"
export * from "./FinishEvent.vue?vue&type=script&lang=js"
import style0 from "./FinishEvent.vue?vue&type=style&index=0&id=24b0e31e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports